<template>
    <div class="empty-state-notification">
        <span class="icon icon-empty-set"></span>
        <div class="empty-state-notification__content">
            <span v-html="content"></span>
            <span class="hint" v-html="hint"></span>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'empty-state-notification',
        props: {
            content: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: ''
            }
        },
    }
</script>

<style lang="scss" scoped>
    .empty-state-notification {
        font-family: 'PlusJakartaSans-Medium', sans-serif;
        display: flex;
        background: $peach;
        padding: 30px 20px;
        flex-direction: row;
        align-items: flex-start;
        margin: 0 0 32px;
        font-size: 2.2rem;
        border-radius: 10px;

        [class*="mobile"] & {
            flex-direction: column;
        }

        &__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            word-break: break-word;
            align-items: flex-start;

        }

        .icon  {
            font-size: 2.4rem;
            margin: 0 20px 0 0;

            [class*="mobile"] & {
                margin: 0 0 20px;
                display: flex;
                align-self: center;
            }
        }

        .hint {
            font-size: 1.8rem;
            margin: 20px 0 30px 0;
            line-height: 150%;
        }
    }
</style>
